import {TextInput as PeacockTextInput} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').ITextInputProps} TextInputProps
 * @property {boolean} [disabled] When true, input is disabled.
 * @property {boolean} [required] When true, marks input as required.
 * @property {boolean} [optional] When true, marks input as optional.
 * @property {import('@pepsico-ds/ui').ILabelProps | string} [label] Input label configuration.
 * @property {string} [placeholderText] Placeholder text.
 * @property {'medium' | 'small'} [inputSize] Input size.
 * @property {string | import('react').ReactNode} [helperText] Helper text shown under input.
 * @property {string} [error] Error text shown under input.
 * @property {(value: string) => void} [onUpdate] Callback triggered with updated input value.
 * @property {(evt: import('react').ChangeEvent<HTMLInputElement>, valueWithPrefixSuffix: string) => void} [onChange] Change callback.
 * @property {boolean} [isPassword] When true, renders password mode.
 * @property {'none' | 'label' | 'dropdown'} [prefixType] Prefix rendering type.
 * @property {string} [prefixLabel] Prefix label.
 * @property {import('@pepsico-ds/ui').FilterProps} [prefixDropdownProps] Prefix dropdown props.
 * @property {'none' | 'label' | 'dropdown'} [suffixType] Suffix rendering type.
 * @property {string} [suffixLabel] Suffix label.
 * @property {import('@pepsico-ds/ui').FilterProps} [suffixDropdownProps] Suffix dropdown props.
 * @property {boolean} [skeleton] When true, renders skeleton state.
 * @property {boolean} [showInLineFeedback] When true, shows inline feedback.
 * @property {string} ['data-cy'] Optional Cypress test attribute.
 */

/**
 * Wrapper around Peacock DS TextInput.
 * Supports all Peacock DS text input props.
 * @param {TextInputProps} props
 */
export const TextInput = props => {
  return <PeacockTextInput {...props} />
}
